export enum AlertMessagesStatus {
  READ = 'read',
  UNREADED = 'unread',
}
